module.exports = __webpack_public_path__ + "img/hide_invoice.1f7c5843.svg";